import { get, isMockMode, simulateDelay } from "../api";

export const getProductsForLicenceView = (data) => {
	if (isMockMode()) {
		const testData = [
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
		];

		return simulateDelay(50, () => testData);
	}

	return get(`products/getforlicenceview?orgId=${data.orgId}`, data);
};
